import { useTranslation } from "lib/i18n/use-translation";
import { TocMetaDraftStatus } from "lib/types";

import css from "./draft-info.module.scss";

interface DraftInfoProps {
  draftStatus: TocMetaDraftStatus;
  fullLength: number;
  updated: string;
  created: string;
}

export function DraftInfo({
  draftStatus,
  fullLength,
  updated,
  created,
}: DraftInfoProps) {
  const { t } = useTranslation();

  const CHARS_PER_PAGE = 2000;

  const expectedChars = parseInt(draftStatus.expected_chars || "0", 10);
  const hasExpectedChars = expectedChars > 0;

  const currentPages = Math.round(fullLength / CHARS_PER_PAGE);
  const expectedPages = Math.round(expectedChars / CHARS_PER_PAGE);

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    return formatter.format(date).replace(" г.", "");
  }

  const days = parseInt(draftStatus.expected_frequency);
  const hasExpectedFrequency = days > 0;

  return (
    <div className={css.draftInfo}>
      <div className={css.content}>
        <div className={css.titleBlock}>
          <div className={css.draftTitle}>
            {t("Автор пишет эту книгу ")}{" "}
            <span className={css.titleHighlight}>{t("прямо сейчас")}</span>
          </div>
        </div>
        <div className={css.detailsBlock}>
          {hasExpectedChars && (
            <div className={css.draftRow}>
              <span className={css.label}>{t("Написано")}:</span>
              <span className={css.value}>
                {currentPages}/{t("{{amount}} стр.", { amount: expectedPages })}
              </span>
            </div>
          )}
          <div className={css.draftRow}>
            <span className={css.label}>{t("Последнее обновление")}:</span>
            <span className={css.value}>{formatDate(updated)}</span>
          </div>
          {hasExpectedFrequency && (
            <div className={css.draftRow}>
              <span className={css.label}>{t("Выход новых глав")}:</span>
              <span className={css.value}>
                {t("примерно раз в {{count}} день", { count: days })}
              </span>
            </div>
          )}
          <div className={css.draftRow}>
            <span className={css.label}>{t("Начало написания")}:</span>
            <span className={css.value}>{formatDate(created)}</span>
          </div>
        </div>
        <div className={css.linkBlock}>
          <a
            href={`${import.meta.env.VITE_LITRES_URL}/chernoviki/`}
            target="_blank"
            rel="noopener noreferrer"
            className={css.draftLink}
          >
            {t("Подробнее о Литрес Черновиках")}
          </a>
        </div>
      </div>
    </div>
  );
}
